<script lang="ts" setup>
import ErrorNotFound from '@/components/Error/ErrorNotFound.vue'
import ErrorSomethingWrong from '@/components/Error/ErrorSomethingWrong.vue'

import type { NuxtError } from 'nuxt/app'

interface Props {
  error: NuxtError
}

const props = defineProps<Props>()

const errorComponent = computed(() =>
  Number(props.error.statusCode) === 404
    ? markRaw(ErrorNotFound)
    : markRaw(ErrorSomethingWrong),
)
</script>

<template>
  <NuxtLayout>
    <component :is="errorComponent" />
  </NuxtLayout>
</template>
